var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialIconWeibo8D086Fbadf4Dfd9E1Cacac28Fcc13D01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 28728",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.536,
    height: 29.536,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 75",
    d: "M13.871 14.046a6.539 6.539 0 00-.9.02c-2.491.245-4.395 1.773-4.233 3.41s2.33 2.773 4.821 2.528 4.375-1.773 4.213-3.41c-.143-1.432-1.819-2.475-3.901-2.548zm1.274 3.88a2.7 2.7 0 01-3.214 1.372 1.857 1.857 0 01-1.176-2.646 2.663 2.663 0 012.136-1.391 2.6 2.6 0 01.9.078 1.846 1.846 0 011.353 2.587z",
    fill: "#e1162c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 76",
    d: "M13.564 16.648a.231.231 0 00-.1-.02.385.385 0 00-.314.176.252.252 0 00.117.373.361.361 0 00.431-.157.255.255 0 00-.134-.372z",
    fill: "#e1162c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 77",
    d: "M12.613 17.047a.857.857 0 00-.314-.059.961.961 0 00-.8.451.666.666 0 00.255 1 .94.94 0 001.137-.392.664.664 0 00-.278-1z",
    fill: "#e1162c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 78",
    d: "M14.768 0a14.768 14.768 0 1014.767 14.768A14.768 14.768 0 0014.768 0zm-1.224 20.909c-3.146 0-6.356-1.52-6.356-4.026a6.56 6.56 0 012.25-4.264 7.344 7.344 0 013.849-2.25 1.322 1.322 0 011.125.316 1.746 1.746 0 01.178 1.776c-.123.385.355.158.355.158 1.542-.646 2.9-.683 3.4.02a1.615 1.615 0 01-.02 1.52c-.111.282.042.311.257.375a2.3 2.3 0 011.836 2.073c-.004 1.901-2.751 4.302-6.873 4.302zm5.507-8.9a.991.991 0 00-.928-.3.494.494 0 01-.592-.375.522.522 0 01.4-.611 1.97 1.97 0 012.27 2.526.5.5 0 01-.948-.316.942.942 0 00-.201-.926zm3.1 1.875a.581.581 0 01-1.105-.355 2.845 2.845 0 00-3.316-3.671.585.585 0 01-.237-1.145 4.015 4.015 0 014.658 5.172z",
    fill: "#e1162c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIconWeibo8D086Fbadf4Dfd9E1Cacac28Fcc13D01);
export default __webpack_public_path__ + "static/media/social-icon-weibo.8d086fbadf4dfd9e1cacac28fcc13d01.8d086fbadf4dfd9e1cacac28fcc13d01.svg";
export { ForwardRef as ReactComponent };